import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';

interface IProps {
  ref?: any;
  section: any;
}

const View = (props: IProps) => {
  return (
    <div style={{ marginBottom: '.3rem' }}>
      <table className={'preview-table preview-unit-table preview-bottom-border'}>
        <colgroup>
          <col width={'20%'} />
          <col />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          {props.section.items?.map((item: any, ii: number) => {
            return (
              <tr key={ii}>
                <th>{item.label}</th>
                <td></td>
                <th>{item.unit}</th>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default View;
